
import Stack, { StackProps } from '@mui/material/Stack';
import { QuestionPaper } from './QuestionPaper';
import { IQuestion } from '../types';
import { SettingsContext } from '../settings/settingsProvider';
import { useContextWithGuard } from '../helpers/useContextWithGuard';
import { useState } from 'react';
import { InfoModal } from './showInfoModal';
import { ShowInfoButton } from './showInfoButton';
import { Theme, useTheme } from '@mui/material';
import { useAnalytics } from '../firebase/firebase';

interface QuestionListProps {
    data: IQuestion[];
}

export const QuestionList = (props: QuestionListProps) => {
    const { track } = useAnalytics();
    const theme = useTheme<Theme>();
    // const { showFaulty } = useContextWithGuard(SettingsContext, "SettingsContext");
    const [showInfoQuestion, setShowInfoQuestion] = useState<IQuestion | null>(null);

    const propss: StackProps = {
        direction: "row",        // horizontal layout
        spacing: 1,            // gap between items
        useFlexGap: true,              // optional, for gap support
        flexWrap: "wrap",        // ✅ allow wrapping
        gap: 1
    }

    return (
        <Stack {...propss}
            sx={{
                borderStyle: "solid none none none",
                borderWidth: "2px",
                borderColor: theme.bee.darkBorder,
            }}>
            {
                // props.data.filter(q => showFaulty || q.fault_clicks === 0)
                props.data
                    .map(q => <QuestionPaper question={q} key={q.id}
                        showInfoButton={
                            <ShowInfoButton onClick={() => {
                                setShowInfoQuestion(q);
                                track("item.info", { id: q.id, collection: q.collection })
                            }} />
                        } />)
            }

            <InfoModal question={showInfoQuestion} setQuestion={setShowInfoQuestion} />
        </Stack>
    )
}